import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unfinished-order-list" }

import { ref, computed, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  createDialog,
  BaseTable,
  XrkMessage
} from 'xrk-components';

import { noPayOrderPageList } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  projectNameCol,
  customerNameCol,
  orderTypeCol,
  orderTimeCol,
  csoPriceSumCol,
  csoPayProgressCol,
  payStatusCol,
  payPassagewayCol,
  csoPayTypeCol,
  payTypeCol,
  orderPriceCol
} from '../fields/columns';
import {
  orderNoSearch,
  projectNameSearch,
  customerNameSearch,
  orderTimeAtSearch,
  payStatusSearch,
  payPassagewayNameSearch,
  csoPayTypeSearch,
  supplierPayTypeSearch
} from '../fields/searchs';

import PayInfoConfirm from './pay-info-confirm.vue';
import ComprehensiveOrderModel from './comprehensive-order-model.vue';

import emitter from '../utils/event-bus';

const selectKey = 'id';


export default /*#__PURE__*/_defineComponent({
  __name: 'unfinished-order-list',
  setup(__props) {

const xrkTableRef = ref<XrkTableRef>();
const router = useRouter();
const route = useRoute();
const onRefreshTabel = (clearSelectionRows = false) => {
  xrkTableRef.value?.initCurrentList();
  clearSelectionRows && xrkTableRef.value?.clearSelectionRows();
};

const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});

onMounted(() => {
  emitter.on('refresh-order-tabel', () => {
    onRefreshTabel(true);
  });
});

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [
    { ...orderNoSearch, defaultValue: route.query.orderNo },
    projectNameSearch,
    customerNameSearch,
    orderTimeAtSearch,
    payStatusSearch,
    payPassagewayNameSearch,
    csoPayTypeSearch,
    supplierPayTypeSearch
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['未完结订单_发起支付']]}
              type="primary2"
              onClick={() => {
                if (!selectionVal.value.length) {
                  XrkMessage.error('请选择一条数据');
                  return;
                }
                createDialog({
                  title: '发起订单支付',
                  showFooter: false,
                  contentRender: done => {
                    return (
                      <div style="padding: 20px">
                        <PayInfoConfirm
                          done={done}
                          payInfo={selectionVal.value}
                        />
                      </div>
                    );
                  }
                });
              }}
            >
              发起支付
            </BaseButton>
          </>
        );
      }
    }
  ]
});

const onSelectItems = async (rows, callBackFn?: () => void) => {
  try {
    const dataList = rows
      .map(item => {
        return item.feeList;
      })
      .flat()
      .filter(Boolean);
    if (!dataList.length) {
      return;
    }
    createDialog({
      title: '提示',
      width: 800,
      showClose: false,
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>您勾选的订单，有关联的综合服务费需要同步支付，请确认。</span>
            <BaseTable
              style="min-height: 300px"
              ref="baseTableRef"
              data={dataList as any[]}
              columns={[
                orderNoCol,
                projectNameCol,
                orderTypeCol,
                orderPriceCol,
                useTableColumn({
                  align: 'center',
                  fixed: 'right',
                  label: '操作',
                  render({ row }) {
                    return (
                      <>
                        <div>
                          <BaseButton
                            style="margin-right: 12px"
                            onClick={async () => {
                              createDialog({
                                title: '综合服务费明细',
                                showFooter: false,
                                contentRender: () => {
                                  return (
                                    <div style="padding: 20px">
                                      <ComprehensiveOrderModel
                                        id={row.id}
                                      ></ComprehensiveOrderModel>
                                    </div>
                                  );
                                }
                              });
                            }}
                            type="text"
                          >
                            查看明细
                          </BaseButton>
                        </div>
                      </>
                    );
                  }
                })
              ]}
            ></BaseTable>
          </div>
        );
      },
      async beforeConfirm(done) {
        callBackFn?.();
        done();
      },
      beforeCancel(done) {
        done();
        rows.forEach((item: any) => {
          xrkTableRef.value.removeSelectionRow(item.idAndOrderType);
        });
      }
    });
  } catch (error) {
    rows.forEach((item: any) => {
      xrkTableRef.value.removeSelectionRow(item.idAndOrderType);
    });
  }
};

watch(
  () => selectionVal.value,
  async (v, oldV) => {
    if (!v.length) {
      return;
    }

    if (oldV.length > v.length) {
      return;
    }
    // 将本次选中的数据筛选出来
    const ids = oldV.map(item => item[selectKey]);
    const selections = v.filter(item => {
      return !ids.includes(item[selectKey]);
    });
    onSelectItems(selections);
  }
);

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: selectKey,
      align: 'center',
      fixed: 'left',
      selectionDisabled(row) {
        // 订单状态为已支付或者已支付
        return [3, 1].includes(+row.payStatus);
      }
    }),
    indexCol,
    orderNoCol,
    projectNameCol,
    customerNameCol,
    orderTypeCol,
    orderTimeCol,
    csoPriceSumCol,
    csoPayProgressCol,
    payStatusCol,
    payPassagewayCol,
    csoPayTypeCol,
    payTypeCol,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 230,
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                disabled={[1, 3].includes(row.payStatus)}
                onClick={async () => {
                  // 修改
                  const routeData = router.resolve({
                    path: '/main/supplier/order/detail',
                    query: {
                      id: row.id,
                      isEdit: 1
                    }
                  });
                  window.open(routeData.href);
                }}
                type="text"
              >
                修改
              </BaseButton>

              <BaseButton
                onClick={async () => {
                  // 查看明细
                  const routeData = router.resolve({
                    path: '/main/supplier/order/detail',
                    query: {
                      id: row.id,
                      isEdit: 0
                    }
                  });
                  window.open(routeData.href);
                }}
                type="text"
              >
                查看明细
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ],
  baseConfig: {}
});

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];
  const [orderPayStartTime, orderPayEndTime] = params.orderPayTime || ['', ''];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime,
    orderPayStartTime,
    orderPayEndTime
  };
  const data = await noPayOrderPageList(reqData);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      style: {"height":"720px"},
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})